import React, { useCallback, useContext, useMemo } from 'react';

import { FormikProps } from 'formik';

import TriggerOnHoverData from '../../../../views/compound-triggers/components/TriggerOnHoverData';

import { FormulaType } from '../../../../constants/formulaType';

//context
import { EditorContext } from '../../../../context/EditorContext';

// hooks
import useCompoundTriggers from '../../../../hooks/compound-trigger/useCompoundTriggers';

import { CompoundTriggerType } from '../../../../models/compound-trigger.model';
//models
import { FormulaTypesData } from '../../../../models/formula.model';

// constants
import { SearchableSelectType } from '../../../inputs/searchableSelect';
// components
import AampeCreateSelectDropdown from '../../../shared/AampeCreateSelectDropdown/AampeCreateSelectDropdown';

interface CompoundTriggerInputProps {
    formikProps: FormikProps<{
        compound_trigger: { label: string; value: string };
    }>;
    menuPortalId?: string;
    isFormSubmitAllowed?: boolean;
    label?: string;
    isDisabled?: boolean;
}

const CompoundTriggerInput: React.FC<
    React.PropsWithChildren<CompoundTriggerInputProps>
> = ({
    formikProps,
    menuPortalId = '',
    isFormSubmitAllowed,
    label,
    isDisabled,
}) => {
    const {
        editorDetails: { formulaType, formula },
    } = useContext(EditorContext);

    const { data, isPending: isLoading } = useCompoundTriggers();

    const { values, setFieldValue, setFieldTouched } = formikProps;

    const selectOptions = useMemo<SearchableSelectType[]>(() => {
        return (data || [])
            .filter((trigger) => !trigger.archived_at)
            .map((trigger) => ({
                value: trigger.id,
                label: trigger.name,
                isDisabled: formula?.cms_type
                    ? [
                          CompoundTriggerType.SEND_IMMEDIATELY,
                          CompoundTriggerType.SEND_WITH_DELAY,
                      ].includes(trigger.trigger_type)
                    : false,
            }));
    }, [data, formula]);

    const handleChange = (name: string, value: SearchableSelectType) => {
        setFieldValue('compound_trigger', value);
        if (isFormSubmitAllowed) {
            formikProps.handleSubmit();
        }
    };

    const menuPortal = document.getElementById(menuPortalId);

    const hoveredOptionTrigger = useCallback(
        (value: string) => data?.find((item) => item.id === value),
        [data],
    );

    if (!FormulaTypesData[formulaType as FormulaType]?.supportTrigger) {
        return null;
    }

    return (
        <AampeCreateSelectDropdown
            label={label ?? 'Triggers'}
            options={selectOptions}
            name={'compound_trigger'}
            value={values.compound_trigger}
            onChange={handleChange as any}
            onBlur={setFieldTouched}
            placeholder={'Select trigger'}
            isLoading={isLoading}
            menuPortalTarget={menuPortal}
            isDisabled={isDisabled}
            infoDescription="What actions make a user eligible for these messages? (Build triggers here.)"
            components={{
                Option: (props) => (
                    <TriggerOnHoverData
                        {...props}
                        trigger={hoveredOptionTrigger(
                            props.data.value.toString(),
                        )}
                    />
                ),
            }}
        />
    );
};

export default CompoundTriggerInput;
